export default "__VITE_ASSET__BMcC$Fqi__"